import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Alert from '../SolvPatternLibrary/Icons/Alert';
import { smallerThanOrEqualTo } from '../../core/util/styledComponents';
import { colors } from '../../constants/colors';
import { fontFamily, fontSize } from '../../constants/text';

const Root = styled.div`
  width: 90% !important;
  background-color: ${colors.canary};
  padding: 5%;
  margin: 20px auto 0;
  box-sizing: border-box;
`;

const Header = styled.div`
  display: flex;
  width: 100px;
  margin: 0 auto;
`;

const Text = styled.div`
  color: ${colors.mrGray};
  line-height: 26px;
  font-size: ${fontSize.mediumSmall};
  width: 100%;
  margin: 0 auto;
  text-align: center;
`;

const Title = styled.div`
  color: ${colors.squid};
  font-size: ${fontSize.medium};
  width: 100%;
  margin: 0 auto;
  line-height: 39px;
  text-align: center;
  font-family: ${fontFamily.bold};
`;

const A = styled.a`
  cursor: pointer;
  color: ${colors.blueJayWay};
`;

const Label = styled.div`
  color: ${colors.ladyInRed};
  font-size: ${fontSize.mediumSmall};
  line-height: 18px;
  font-family: ${fontFamily.bold};
  width: 155px;
  ${smallerThanOrEqualTo.sm`
    width: 80%;
  `};
`;

class EmergencyMessage extends PureComponent {
  render() {
    return (
      <Root>
        <Header>
          <Alert /> <Label>WARNING</Label>
        </Header>
        <Title>Possible Emergency</Title>
        <Text>
          Your reason for visit could be a sign of a life threatening emergency. Please review the{' '}
          <A href="http://www.911.gov/">guidelines for calling 911</A> and consider visiting the
          nearest Emergency Room.
        </Text>
      </Root>
    );
  }
}

export default EmergencyMessage;
